import api from 'lib/api';


//curl -d "video_idx=100&card_idx=60&language=en" -H "Content-Type: application/x-www-form-urlencoded" -X POST https://api.boomco.org/video/view2
//video_idx: item.videoIdx, card_idx:item.categoryId, language:launge.languageTag
//

export const postYoutubeDetail = (item) => {
    return api.post('/video/view2', item);
}



